export const isStorageAvailable = () => {
  try {
    localStorage.getItem('ipoKey');
    return true;
  } catch (e) {
    return false;
  }
};
